//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/PcbExchange.js";
import "../no/TransientObject.js";
let d=[[[0,"InterferenceCount",0,0]],[[["count"],"GetInterferences",{R_:{interferences:"PcbExchange.DesignInterference[]"}},0,0],[[],"PerformAnalysis",{},0,0],[[],"ResetAnalysis",{},0,0],[["filename"],"ExportInterferences",{},1,0],[[],"Dispose",{},0,0],[["isWorkPartOnly"],"PerformAnalysisBasedOnScope",{},1,0]],[]];
SPLM.PcbExchange.DesignValidator = class extends SPLM.TransientObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.PcbExchange.DesignValidator";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;